import { AdapterFactory } from './adapter-factory';

export const GenericAdapter = AdapterFactory({});
